import { render } from "./baseInputNumber.vue?vue&type=template&id=4084b8f8"
import script from "./baseInputNumber.vue?vue&type=script&lang=js"
export * from "./baseInputNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__